/**
 * @file The WithdrawAssignmentComponent is used to retract an assignment and put it back to the marketplace
 * The component is activated with an action button and displayed in the overlay
 * @author Maarten Lensink
 */
import { ActivatedRoute, Router } from '@angular/router';
import { OverlayProvider } from '../../ui/overlay-provider';
import { OverlayService } from '../../core/overlay.service';
import { DomainService } from '../../domain.service';
import { AlertsService } from '../../core/alerts.service';
import { RoutesService } from '../../routes.service';
/**
 * Allows the user to confirm or cancel withdraw the marketplace assignment
 * @export
 * @class WithdrawAssignmentComponent
 */
var WithdrawAssignmentComponent = /** @class */ (function () {
    /**
     * Creates an instance of WithdrawAssignmentComponent
     * @param {DomainService} domainService The domain service
     * @param {OverlayService} overlayService The overlay service
     * @param {AlertsService} alertsService The alert service
     * @param {OverlayProvider} overlayProvider The overlay provider contains the entity
     */
    function WithdrawAssignmentComponent(domainService, overlayService, alertsService, route, router, overlayProvider) {
        this.domainService = domainService;
        this.overlayService = overlayService;
        this.alertsService = alertsService;
        this.route = route;
        this.router = router;
        if (overlayProvider.entity['Item']) {
            this.entity = overlayProvider.entity['Item'];
        }
        else {
            this.entity = overlayProvider.entity;
        }
    }
    /**
     * Deletes the assignment, removes the resource from the deployment and closes the overlay
     * @param {any} event The click event that triggered this method
     */
    WithdrawAssignmentComponent.prototype.confirm = function (event) {
        var _this = this;
        if (event) {
            event.target.classList.add('sym-working');
        }
        this.entity['Deployment']['Resource_Oid'] = '';
        this.domainService.setDeleted(this.entity);
        this.domainService.saveChanges(function (error) {
            if (error) {
                _this.alertsService.createAlert('warning', 'APP.MARKETPLACE.ITEM_UNSUCCESSFULLY_WITHDRAWN');
            }
            else {
                _this.alertsService.createAlert('success', 'APP.MARKETPLACE.ITEM_SUCCESSFULLY_WITHDRAWN');
                _this.navigateToClose();
            }
            _this.overlayService.closeOverlay();
        });
    };
    /**
     * Closes the overlay
     */
    WithdrawAssignmentComponent.prototype.cancel = function () {
        this.overlayService.closeOverlay();
    };
    WithdrawAssignmentComponent.prototype.navigateToClose = function () {
        var _this = this;
        var queryParams = {};
        Object.keys(this.route.snapshot.queryParams).forEach(function (key) {
            queryParams[key] = _this.route.snapshot.queryParams[key];
        });
        queryParams['delete-result'] = this.entity['Oid'];
        RoutesService.navigateBack(this.router, this.route, queryParams);
    };
    return WithdrawAssignmentComponent;
}());
export { WithdrawAssignmentComponent };
